import { useEffect, useState } from 'react';

import type { WProductView } from '@zola/svc-web-api-ts-client';
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

import _get from 'lodash/get';

const usePDPActiveNavItems = ({
  isBaby,
  productData,
}: {
  isBaby: boolean;
  productData: WProductView | null;
}) => {
  const [activePrimaryLink, setActivePrimaryLink] = useState(PrimaryNavIdentifier.REGISTRY);
  const [activeSecondaryLink, setActiveSecondaryLink] = useState('');

  useEffect(() => {
    const isWeddingBoutique = _get(productData, 'wedding_shop_nav_details.secondary_nav_item_key');
    if (isWeddingBoutique) {
      setActivePrimaryLink(PrimaryNavIdentifier.WEDDING_BOUTIQUE);
    }
    if (isBaby) {
      setActivePrimaryLink(PrimaryNavIdentifier.SHOP);
    }

    const topLevelCategory = _get(productData, 'category_chain[0].key');
    setActiveSecondaryLink(topLevelCategory);
  }, [isBaby, productData]);

  return {
    activePrimaryLink,
    activeSecondaryLink,
    isWeddingBoutiquePage: activePrimaryLink === PrimaryNavIdentifier.WEDDING_BOUTIQUE,
  };
};

export default usePDPActiveNavItems;
